import { fleetsUrl, roleListApiUrl } from "../Common/endpoints";
import { Card, Col, Row } from "antd";
import { getApis } from "../Common/apis";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setDealerSlideShow, setRoles } from "../../reducers/authSlice";
import RegisterForm from "./Form";
import { ORG_TYPES, ROLES } from "../Common/Constants";
import { useRequiredAccess } from "../../hooks/useRequiredAccess";

const Register = () => {
  const dispatch = useDispatch();
  const [fleetList, setFleetList] = useState([]); 
  const userToken = localStorage.getItem("userToken");
  const checkAccess = useRequiredAccess(
    [ROLES.ADMIN],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER, ORG_TYPES.DEALER]
  );

  useEffect(() => {
    checkAccess();
    dispatch(setDealerSlideShow(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const getRoles = useCallback(async () => {
    await getApis(roleListApiUrl, {}, userToken)
      .then((response) => dispatch(setRoles(response.data)))
      .catch((e) => console.log(e));
  }, [dispatch, userToken]);

  const getFleets = async () => {
    await getApis(fleetsUrl, {}, userToken)
      .then((response) => {
        setFleetList(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getRoles();
    getFleets();

    // eslint-disable-next-line
  }, [getRoles]);

  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={12} lg={10} xl={10}>
        <Card title="Add User" styles={{ body: { padding: "1rem 1.5rem" } }}>
          <RegisterForm fleetList={fleetList} />
        </Card>
      </Col>
    </Row>
  );
};

export default Register;
